import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { Svgs } from './Svgs';

class Online extends Component {

  constructor(props) {
    super(props);

    this.state = {
      title: null,
      copy: null,
      class: null,
      component: null,
      close: false
    }
  }

  componentDidMount() {
    this.dom = ReactDOM.findDOMNode(this);
    this.setState({
      title: null,
      copy: null,
      class: null,
      component: null,
      close: false
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.class) {
      this.dom.classList.remove(this.state.class);
    }
    if (nextProps.overlayMessage) {
      if (nextProps.overlayMessage.class) {
        this.dom.classList.add(nextProps.overlayMessage.class);
      }
      this.setState({
        title: nextProps.overlayMessage.title,
        copy: nextProps.overlayMessage.copy,
        close: nextProps.overlayMessage.close,
        class: nextProps.overlayMessage.class,
        component: nextProps.overlayMessage.component
      });
    }
    if (nextProps.overlayToggle) {
      this.dom.classList.add('overlay--open');
    } else {
      this.dom.classList.remove('overlay--open');
    }
  }

  closeOverlay = (e) => {
    this.dom.classList.remove('overlay--open');
  }

  outerCloseOverlay = (e) => {
    this.dom.classList.remove('overlay--open');
  }

  innerCloseOverlay = (e) => {
    e.stopPropagation();
  }

  render() {
    return (
      <div className='overlay' onClick={(e) => this.outerCloseOverlay(e)}>
        <div className="overlay__wrap" onClick={(e) => this.innerCloseOverlay(e)}>
          {this.state.close &&
            <button type="button" className="overlay__close-btn" onClick={(e) => this.closeOverlay(e)}><Svgs width="12" height="12" svg="Close" /></button>
          }
          {this.state.component &&
            this.state.component
          }
          {this.state.title &&
            <h3>{this.state.title}</h3>
          }
          {this.state.copy &&
            <p>{this.state.copy}</p>
          }
        </div>
      </div>
    );
  }
}

export default Online;



// WEBPACK FOOTER //
// ./src/components/Overlay.js